import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useRef, useState } from 'react'
import useAnimateScroll from '../../hooks/use-animate-scroll'
import Button from '../Button'
import { Container, Wrapper } from './styles'

interface Props {
  buttonOut?: boolean
  padding?: boolean
  perPage: number
  children: React.ReactNodeArray
  style?: any
}

const Carousel: React.FC<Props> = ({
  children,
  perPage,
  padding = false,
  buttonOut = false,
  style = {}
}) => {
  const ref = useRef<HTMLDivElement>(null)
  const [state, setState] = useState<'start' | 'middle' | 'end'>('start')
  const scrollTo = useAnimateScroll()

  useEffect(() => {
    const carousel = ref.current

    if (carousel) {
      carousel.onscroll = () => {
        if (carousel.scrollLeft === 0) {
          setState('start')
        } else if (
          carousel.clientWidth + carousel.scrollLeft === carousel.scrollWidth
        ) {
          setState('end')
        } else {
          setState('middle')
        }
      }
    }
  }, [ref])

  const handleClick = (to: string) => {
    const carousel = ref.current

    if (carousel && children) {
      const itemWidth = carousel.scrollWidth / children.length
      scrollTo(carousel, carousel.scrollLeft + itemWidth * (to === 'prev' ? -1 : 1), 200)
    }
  }

  return (
    <Wrapper
      padding={padding}
      buttonOut={buttonOut}
      state={state}
      style={{ ...style }}
    >
      <Button
        style={{
          color: 'rgba(0,0,0,0.12)',
          fontSize: '25px',
        }}
        label={(
          <FontAwesomeIcon icon={faChevronLeft} />
        )}
        backgroundColor="transparent"
        smallPadding
        onClick={() => handleClick('prev')}
      />
      <Container
        ref={ref}
        items={children.length || 0}
        perPage={perPage}
      >
        {children}
      </Container>
      <Button
        style={{
          color: 'rgba(0,0,0,0.12)',
          fontSize: '25px',
        }}
        label={(
          <FontAwesomeIcon icon={faChevronRight} />
        )
        }
        backgroundColor="transparent"
        smallPadding
        onClick={() => handleClick('next')}
      />
    </Wrapper>
  )
}

export default Carousel
